export const newMappingRowPayload = {
	id: -1,
	order: 0,
	columnCode: '',
	keyFlag: false,
	updateFlag: false,
	mapping: '',
	mappingDescription: '',
}

export const SOURCE_ITEM_UUID = 'objectUuid'
export const newSourceItemPayload = {
	id: -1,
	order: 0,
	alias: '',
	ownerId: undefined,
	objectId: undefined,
	ownerName: undefined,
	expression: undefined,
	objectCode: undefined,
	objectType: undefined,
	stereotype: undefined,
}

export const newPermissionPayload = {
	id: -1,
	order: 0,
	permissions: [],
	user: undefined,
}

export const newTableColumnPayload = {
	id: -1,
	order: 0,
	name: '',
}
